import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/messages';

const namespace = 'MESSAGES';

export const FETCH_MESSAGES_START = `${namespace}/FETCH_MESSAGESS_START`;
export const FETCH_MESSAGES_SUCCESS = `${namespace}/FETCH_MESSAGESS_SUCCESS`;
export const FETCH_MESSAGES_ERROR = `${namespace}/FETCH_MESSAGESS_ERROR`;

export const fetchMessages = makeApiActionCreatorV3(
  api.fetchMessages,
  FETCH_MESSAGES_START,
  FETCH_MESSAGES_SUCCESS,
  FETCH_MESSAGES_ERROR,
);

export const INSERT_MESSAGE_START = `${namespace}/INSERT_MESSAGE_START`;
export const INSERT_MESSAGE_SUCCESS = `${namespace}/INSERT_MESSAGE_SUCCESS`;
export const INSERT_MESSAGE_ERROR = `${namespace}/INSERT_MESSAGE_ERROR`;

export const insertMessage = makeApiActionCreatorV3(
  api.insertMessage,
  INSERT_MESSAGE_START,
  INSERT_MESSAGE_SUCCESS,
  INSERT_MESSAGE_ERROR,
);

export const FETCH_CHILD_MESSAGES_START = `${namespace}/FETCH_CHILD_MESSAGES_START`;
export const FETCH_CHILD_MESSAGES_SUCCESS = `${namespace}/FETCH_CHILD_MESSAGES_SUCCESS`;
export const FETCH_CHILD_MESSAGES_ERROR = `${namespace}/FETCH_CHILD_MESSAGES_ERROR`;

export const fetchChildMessages = makeApiActionCreatorV3(
  api.fetchChildMessages,
  FETCH_CHILD_MESSAGES_START,
  FETCH_CHILD_MESSAGES_SUCCESS,
  FETCH_CHILD_MESSAGES_ERROR,
);

export const INSERT_MESSAGE_FILE_START = `${namespace}/INSERT_MESSAGE_FILE_START`;
export const INSERT_MESSAGE_FILE_SUCCESS = `${namespace}/INSERT_MESSAGE_FILE_SUCCESS`;
export const INSERT_MESSAGE_FILE_ERROR = `${namespace}/INSERT_MESSAGE_FILE_ERROR`;

export const insertMessageFile = makeApiActionCreatorV3(
  api.insertMessageFile,
  INSERT_MESSAGE_FILE_START,
  INSERT_MESSAGE_FILE_SUCCESS,
  INSERT_MESSAGE_FILE_ERROR,
);

export const INSERT_CHILD_MESSAGE_START = `${namespace}/INSERT_CHILD_MESSAGE_START`;
export const INSERT_CHILD_MESSAGE_SUCCESS = `${namespace}/INSERT_CHILD_MESSAGE_SUCCESS`;
export const INSERT_CHILD_MESSAGE_ERROR = `${namespace}/INSERT_CHILD_MESSAGE_ERROR`;

export const insertChildMessage = makeApiActionCreatorV3(
  api.insertChildMessage,
  INSERT_CHILD_MESSAGE_START,
  INSERT_CHILD_MESSAGE_SUCCESS,
  INSERT_CHILD_MESSAGE_ERROR,
);

export const UPDATE_MESSAGE_FILE_START = `${namespace}/UPDATE_MESSAGE_FILE_START`;
export const UPDATE_MESSAGE_FILE_SUCCESS = `${namespace}/UPDATE_MESSAGE_FILE_SUCCESS`;
export const UPDATE_MESSAGE_FILE_ERROR = `${namespace}/UPDATE_MESSAGE_FILE_ERROR`;

export const updateMessageFile = makeApiActionCreatorV3(
  api.updateMessageFile,
  UPDATE_MESSAGE_FILE_START,
  UPDATE_MESSAGE_FILE_SUCCESS,
  UPDATE_MESSAGE_FILE_ERROR,
);

export const DELETE_MESSAGE_FILE_START = `${namespace}/DELETE_MESSAGE_FILE_START`;
export const DELETE_MESSAGE_FILE_SUCCESS = `${namespace}/DELETE_MESSAGE_FILE_SUCCESS`;
export const DELETE_MESSAGE_FILE_ERROR = `${namespace}/DELETE_MESSAGE_FILE_ERROR`;

export const deleteMessageFile = makeApiActionCreatorV3(
  api.deleteMessageFile,
  DELETE_MESSAGE_FILE_START,
  DELETE_MESSAGE_FILE_SUCCESS,
  DELETE_MESSAGE_FILE_ERROR,
);

export const DOWNLOAD_MESSAGE_FILE_START = `${namespace}/DOWNLOAD_MESSAGE_FILE_START`;
export const DOWNLOAD_MESSAGE_FILE_SUCCESS = `${namespace}/DOWNLOAD_MESSAGE_FILE_SUCCESS`;
export const DOWNLOAD_MESSAGE_FILE_ERROR = `${namespace}/DOWNLOAD_MESSAGE_FILE_ERROR`;

export const downloadMessageFile = makeApiActionCreatorV3(
  api.downloadMessageFile,
  DOWNLOAD_MESSAGE_FILE_START,
  DOWNLOAD_MESSAGE_FILE_SUCCESS,
  DOWNLOAD_MESSAGE_FILE_ERROR,
);
